import { render, staticRenderFns } from "./RequestAffordabilityBar.vue?vue&type=template&id=2caf3b96&scoped=true"
import script from "./RequestAffordabilityBar.vue?vue&type=script&lang=js"
export * from "./RequestAffordabilityBar.vue?vue&type=script&lang=js"
import style0 from "./RequestAffordabilityBar.vue?vue&type=style&index=0&id=2caf3b96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caf3b96",
  null
  
)

export default component.exports